// extracted by mini-css-extract-plugin
export default {"fullWidth":"IB-z","image":"JB-z","lazyLoadPicture":"KB-z","lazyLoadSpinner":"LB-z","lazyLoadSpin":"MB-z","lazyLoadImage":"NB-z","hasStyledAspectRatio":"OB-z"};